export interface DailyReportRequestData {
  email: string;
  brokerDomainId?: string;
  partnershipCode: string;
  dayFrom: number;
  dayTo: number;
  yearFrom: number;
  yearTo: number;
  monthFrom: number;
  monthTo: number;
  filterPlatformType: number;
  accountTypeFilter: number;
}

export interface MonthlyReportRequestData {
  email: string;
  brokerDomainId?: string;
  partnershipCode: string;
  yearFrom: number;
  yearTo: number;
  monthFrom: number;
  monthTo: number;
  filterPlatformType: number;
  accountTypeFilter: number;
}

export interface ReportItem {
  // clientsFunded: number;
  // clientsTraded: number;
  // date?: string;
  // depositsUSD: string;
  // lots: number;
  // volumeLots: number;
  // netDepositsUSD: string;
  // trades: number;
  // tradingAccountsFunded: number;
  // tradingAccountsTraded: number;
  // valueUSD: string;
  // withdrawalsUSD: string;
  // emails: string;
  // firstTrade: number;
  date: Date;
  valueUSD: number;
  formattedValueUSD: string;
  lots: number;
  volumes: number;
  volumeLots: number;
  tradingAccountsTraded: number;
  clientsTraded: number;
  tradingAccountsFunded: number;
  clientsFunded: number;
  trades: number;
  depositsUSD: number;
  formattedDepositsUSD: string;
  withdrawalsUSD: number;
  formattedWithdrawalsUSD: string;
  netDepositsUSD: number;
  formattedNetDepositsUSD: string;
  netInternalTransfersOut: number;
  formattedNetInternalTransfersOut?: number;
  netInternalTransfersIn: number;
  formattedNetInternalTransfersIn?: number;
}

export interface TradingSummaryTotals {
  tradesTotal: number;
  tradesTotalPercentage: number;
  tradingAccountsTradedTotal: number;
  tradingAccountsTradedTotalPercentage: number;
  depositsUSDTotal: number;
  depositUsdTotalPercentage: number;
  withdrawalsUsdTotal: number;
  withdrawalsUsdTotalPercentage: number;
  valueUsdTotal: number;
  valueUsdTotalPercentage: number;
  lotsTotal: number;
  lostTotalPercentage: number;
  volumeLotsTotal: number;
  volumeLotsTotalPercentage: number;
  tradingAccountsFundedTotal: number;
  tradingAccountsFundedTotalPercentage: number;
  netDepositsUsdTotal: number;
  netDepositsUsdTotalPercentage: number;
}

export interface TradingSummaryReport {
  items: ReportItem[];
  total: TradingSummaryTotals;
}

export interface DailyEmailReportRequest {
  registrationsDailyFilters: {
    email: null | string;
    brokerFID: number;
    partnershipCode: string;
    yearFrom?: number;
    yearTo?: number;
    monthFrom?: number;
    monthTo?: number;
    filterPlatformType: number;
    filterAccountType: number;
    dayFrom?: number;
    dayTo?: number;
  };
  reportEmailRequest: {
    email: null | string;
    includeTotal: boolean;
    tableColumns: string[];
    startDate: string | null;
    endDate: string | null;
    translatedTableColumns: string[];
  };
  accountGuidAuth: string | undefined;
}

export interface MonthlyEmailReportRequest {
  registrationsMonthlyFilters: {
    email: null | string;
    brokerFID: number;
    partnershipCode: string;
    yearFrom?: number;
    yearTo?: number;
    monthFrom?: number;
    monthTo?: number;
    filterPlatformType: number;
    filterAccountType: number;
  };
  reportEmailRequest: {
    email: null | string;
    includeTotal: boolean;
    tableColumns: string[];
    translatedTableColumns: string[];
    startDate: string | null;
    endDate: string | null;
  };
  accountGuidAuth: string | undefined;
}

export const reportEnColumns = ['date', 'total trades', 'users traded', 'deposits', 'withdrawals (USD)', 'value', 'lots', 'volume Lots', 'users traded (email)', 'funded accounts', 'net deposits'];
